import { addMonths, isAfter, isValid, isPast, isToday } from 'date-fns'
import { DateTimeHelper } from '@/helpers'
import useBasket from '@/hooks/useBasket'

// Hooks
const { getDefaultContractStartDate } = useBasket()

// FLEX-1279 if date in the past or today or too far in future -> invalid, push contract start to next month
export const isInvalidContractStartDate = function (value) {
  if (!value) {
    return true
  }
  const ISODate = DateTimeHelper.parseDate(value)
  const isValidISODate = isValid(ISODate)
  const now = new Date()

  return !isValidISODate || isToday(ISODate) || isPast(ISODate) || isAfter(ISODate, addMonths(now, 20))
}

/**
 * If the start date in the bundle is not valid, the next valid contract start date is the start of the next month (FLEX-1279)
 * @returns {Promise} Promise resolving to ISO date
 */
export const getNewContractStartDate = async () => {
  return await getDefaultContractStartDate()
}
